<div class="tili-num">{{ numero }}</div>
<div class="long-col">{{ label }}</div>
<div app-veroilmoitus-value-read-only [numero]="numero" [veroilmoitus]="veroilmoitus" [format]="format" [desimaaleja]="desimaaleja" [repeatingMetadata]="repeatingMetadata" [log]="log" class="short-col" [class.currency]="format === 'currency' || format === 'km'"></div>
<div class="end-marking">{{ end }}</div>
